export function toggleCoachContactDetails(){
  const coach_contact_details = document.querySelector('.coach-contact-details')
  const coach_contact_details_button = document.querySelector('.toggle-coach-contact-details')

  coach_contact_details.classList.toggle('show')
  coach_contact_details_button.classList.toggle('hide')
}
